/** Student dev mutations refresh their affected student resources before returning. */
import { useApiAction } from '../../_shared/use-api-action';
import { studentDevApi } from './api';
import { studentProgressKeys } from '../progress/keys';
import { studentPortfolioKeys } from '../portfolio/keys';
import { studentCertificatesKeys } from '../certificates/keys';
import { studentCampaignsKeys } from '../campaigns/keys';

const progress = [studentProgressKeys.all(), studentPortfolioKeys.all()];
const certificate = [...progress, studentCertificatesKeys.all(), studentCampaignsKeys.all()];

export function useStudentDevActions() {
  return {
    awardXp: useApiAction(studentDevApi.awardXp, progress),
    awardBadge: useApiAction(studentDevApi.awardBadge, progress),
    removeBadge: useApiAction(studentDevApi.removeBadge, progress),
    adjustEndorsement: useApiAction(studentDevApi.adjustEndorsement, progress),
    adjustSkillPoints: useApiAction(studentDevApi.adjustSkillPoints, progress),
    addAccomplishment: useApiAction(studentDevApi.addAccomplishment, progress),
    deleteAccomplishment: useApiAction(studentDevApi.deleteAccomplishment, progress),
    unlockCertificate: useApiAction(studentDevApi.unlockCertificate, certificate),
    setCampaignRole: useApiAction(studentDevApi.setCampaignRole, progress),
  };
}
